import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IEditUserRoleRequest } from '../models/edit-user-role.model';
import { fromEditUserRole } from '../actions';

export const editUserRoleFeatureKey = 'editUserRole';

export interface EditUserRoleState {
  loadEditUserRoleRequest: IEditUserRoleRequest;
  loadEditUserRoleResponse: string;
  loadEditUserRoleFailure: IGenericError<ErrorResponse>;
}

export const initialState: EditUserRoleState = {
  loadEditUserRoleRequest: undefined,
  loadEditUserRoleResponse: undefined,
  loadEditUserRoleFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromEditUserRole.loadEditUserRoles, (state, action) => ({
    ...state,
    loadEditUserRoleRequest: action.request
  })),
  on(fromEditUserRole.loadEditUserRolesSuccess, (state, action) => ({
    ...state,
    loadEditUserRoleResponse: action.response
  })),
  on(fromEditUserRole.loadEditUserRolesFailure, (state, action) => ({
    ...state,
    loadEditUserRoleFailure: action.error
  }))
);
